import React, { useCallback } from 'react';
import NewReport, { getDefaultProgram } from './NewReport';
import NewProgram from './NewProgram';
import { Program } from '../Reports/NewReportDialog';
import { RequestState } from 'shared/auth/hooks/useRequestState';
import { NPOUser } from './NewProgram/api';

interface AddNewModalsProps {
  defaultProgramName: string | undefined;
  openNewReport: boolean;
  openNewProgram: boolean;
  allNPOUsers: RequestState<{
    allUsers: NPOUser[];
  }>;
  programsList: RequestState<{
    allPrograms: Program[];
  }>;
  reloadProgramList: () => unknown;
  handleReportCountLoad: (() => unknown) | undefined;
  setOpenNewReport: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenNewProgram: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddNewModals: React.FC<AddNewModalsProps> = ({
  defaultProgramName,
  openNewProgram,
  openNewReport,
  allNPOUsers,
  programsList,
  reloadProgramList,
  setOpenNewProgram,
  setOpenNewReport,
  handleReportCountLoad,
}) => {
  const onNewReportClose = useCallback(() => setOpenNewReport(false), [
    setOpenNewReport,
  ]);
  const onNewProgramClose = useCallback(() => setOpenNewProgram(false), [
    setOpenNewProgram,
  ]);

  return (
    <>
      {openNewReport && (
        <NewReport
          open={true}
          programsList={programsList}
          onClose={onNewReportClose}
          handleReportCountLoad={handleReportCountLoad}
          existingProgram={getDefaultProgram(defaultProgramName, programsList)}
        />
      )}
      {openNewProgram && (
        <NewProgram
          open={true}
          allNPOUsers={allNPOUsers}
          programsList={programsList}
          reloadProgramList={reloadProgramList}
          onClose={onNewProgramClose}
        />
      )}
    </>
  );
};

export default AddNewModals;
